import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Offcanvas, Button, Form, Modal } from "react-bootstrap";
import Select from "react-select";

const ProjectsList = [
  {
    id: 1,
    protitle: "E-commerce Website Development",
    budget: "$10,000 - $20,000",
    hourlyRate: "$50 - $100/hr",
    location: "Remote",
    status: "Not Responded",
    description:
      "Looking for an experienced web development team to build a scalable e-commerce platform with payment integration.",
    logo: "https://www.veritis.com/wp-content/themes/veritis/theme/img/logo.svg",
    title: "Veritis Group Inc.",
    lookingToStart: "immediately",
    name: "John Doe",
    email: "johndoe@example.com",
    phone: "123-456-7890",
  },
  {
    id: 2,
    protitle: "Mobile App for Fitness Tracking",
    budget: "$5,000 - $15,000",
    hourlyRate: "$40 - $80/hr",
    location: "United States",
    status: "Accepted",
    description:
      "Need a cross-platform mobile app for tracking workouts, diet plans, and progress with AI-based recommendations.",
    logo: "https://www.wipro.com/content/dam/wipro/social-icons/wipro_new_logo.svg",
    title: "Wipro",
    lookingToStart: "30_60",
    name: "Jane Smith",
    email: "janesmith@example.com",
    phone: "987-654-3210",
  },
];

const ProposalLeads = () => {
  const [projects, setProjects] = useState(ProjectsList);
  const [selectedProject, setSelectedProject] = useState(null);
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleEdit = (project) => {
    setSelectedProject({ ...project });
    setShowEditPanel(true);
  };

  const handleChange = (e) => {
    setSelectedProject({ ...selectedProject, [e.target.name]: e.target.value });
  };

  const handleDelete = (project) => {
    setSelectedProject(project);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    setProjects((prev) => prev.filter((p) => p.id !== selectedProject.id));
    setShowDeleteModal(false);
  };

  const handleSaveEdit = () => {
    setProjects((prev) =>
      prev.map((p) => (p.id === selectedProject.id ? selectedProject : p))
    );
    setShowEditPanel(false);
  };

  return (
    <>
    <div className="row">
      {projects.map((project) => (
        <div key={project.id} className="col-lg-4 col-md-12 col-sm-12 mb-4">
          <div className="card mb-3 p-4 shadow-sm ls-profile rounded-4">
            <h5 className="mb-3">{project.protitle}</h5>
            <div className="d-flex justify-content-between pb-3">
              <div className="badge small border-primary text-primary">Immediate</div>
            </div>
            <p className="text-muted mb-2">{project.description}</p>
            <div className="d-block justify-content-between border-top py-2 pb-3 num-stat my-3 border-bottom w-100 gap-5">
            <ul className="list-group-info">
          <li className="list-group-info d-flex justify-content-between py-2">
            <span className="small fw-500">Budget</span> <span className="fw-600 small text-end">{project.budget}</span>
          </li>
          <li className="list-group-info d-flex justify-content-between py-2">
            <span className="small fw-500">Posted Date</span> <span className="fw-600 small text-end">Feb 14 2024</span>
          </li>
        </ul>
            </div>
            <div className="d-flex align-content-center pt-2">
              <img
                src={project.logo}
                alt={project.title}
                className="me-3 border rounded p-1"
                width="50"
                height="50"
              />
              <div className="ps-0 w-100 d-flex justify-content-between align-content-center">
                <div>
                  <h6 className="p-0 m-0 pb-1">
                    <NavLink to="/CompanyProfile" className="text-black text-decoration-none">
                      {project.title}
                    </NavLink>
                  </h6>
                  <span className="text-primary m-0 small p-0 mt-2">{project.status}</span>
                </div>
                <div>
                  <button
                    className="btn text-primary btn-outline-primary btn-sm mt-2 me-3"
                    onClick={() => handleEdit(project)}
                  >
                    Edit
                  </button>
                  <button className="btn btn-primary btn-sm mt-2 text-white" onClick={() => handleDelete(project)}>
                    Delete
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

      {/* Edit Side Panel */}
      <Offcanvas className="px-3" show={showEditPanel} onHide={() => setShowEditPanel(false)} placement="end">
        <Offcanvas.Header className="border-bottom mb-3" closeButton>
          <Offcanvas.Title>Edit Project</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {selectedProject && (
            <Form>
              <h5 className="mb-3">Project Information</h5>
              <Form.Group className="mb-3">
                <Form.Label>Project Title</Form.Label>
                <Form.Control
                  type="text"
                  name="protitle"
                  value={selectedProject.protitle}
                  onChange={handleChange}
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Project Details</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="description"
                  value={selectedProject.description}
                  onChange={handleChange}
                  placeholder="Describe your project"
                />
              </Form.Group>

              <Form.Group className="mb-4">
                <Form.Label>Looking to Start</Form.Label>
                <Form.Select name="lookingToStart" value={selectedProject.lookingToStart} onChange={handleChange}>
                  <option value="immediately">Immediately</option>
                  <option value="less_than_15">Less than 15 Days</option>
                  <option value="15_30">Between 15-30 Days</option>
                  <option value="30_60">Between 30-60 Days</option>
                  <option value="60_90">Between 60-90 Days</option>
                  <option value="just_looking">We’re Just Looking</option>
                </Form.Select>
              </Form.Group>


              <Form.Group className="mb-3">
              <Form.Label>Budget</Form.Label>
  <Select
    name="budget"
    options={[
      { value: "10000-20000", label: "$10,000 - $20,000" },
      { value: "20000-50000", label: "$20,000 - $50,000" },
      { value: "50000-100000", label: "$50,000 - $100,000" },
    ]}
    value={{
      value: selectedProject?.budget,
      label: selectedProject?.budget
    }} // Ensure correct format
    onChange={(selectedOption) =>
      setSelectedProject((prev) => ({
        ...prev,
        budget: selectedOption.value,
      }))
    }
    placeholder="Select your Budget"
  />
</Form.Group>

              <h5 className="mb-3 pt-4">Contact Person</h5>
              <Form.Group className="mb-4">
                <Form.Label>Name</Form.Label>
                <Form.Control type="text" name="name" value={selectedProject.name} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Email Address</Form.Label>
                <Form.Control type="email" name="email" value={selectedProject.email} onChange={handleChange} />
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control type="tel" name="phone" value={selectedProject.phone} onChange={handleChange} />
              </Form.Group>


              <Button variant="primary" onClick={handleSaveEdit}>
                Save Changes
              </Button>
            </Form>
          )}
        </Offcanvas.Body>
      </Offcanvas>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete this project?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </div>

        </>
  );
};

export default ProposalLeads;
